"use strict";
var React = require('react')
var Link = require('react-router')
var Navigation = require('../Navigation/Navigation')
var LanguageStore = require('../../store/LanguageStore')
var DocMeta = require('react-doc-meta');
var Kontakt = React.createClass({
  componentDidMount() {
      LanguageStore.addChangeListener(this.onChange);
      var title = this.state.lang === 'uk' ? 'Contact | Termovent SC Steal foundry A.D. Bačka Topola' : this.state.lang === 'rs' ?  "Kontakt | Termovent SC Livnica čelika A.D. Bačka Topola" : this.state.lang === 'de' ? "Kontakt | Die Termovent SC Stahlfabrik GmbH" : null
      document.title = title;

    },
    getInitialState() {
        var state = LanguageStore.getLanguage();
        return state;
    },
    onChange() {
        var state = LanguageStore.getLanguage();
        this.setState(state);
    },
    componentWillUnmount() {
        LanguageStore.removeChangeListener(this.onChange);
    },

  render() {
    return(this.state.lang === 'uk' ? this.eng() : this.state.lang === 'rs' ? this.srb() : this.state.lang === 'de' ? this.ger() : null)
  },
  srb(){
    return (
        <div>
      <div className='row text-center col-margin-top-doc'>
      <div className='col-md-2'></div>
        <div className='col-md-8'>
          <iframe  width="100%" height="400" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.rs/maps?f=q&amp;source=embed&amp;hl=sr&amp;geocode=&amp;q=livnica+%C4%8Delika+ba%C4%8Dka+topola&amp;aq=&amp;sll=45.410355,20.207012&amp;sspn=2.090149,4.938354&amp;t=h&amp;ie=UTF8&amp;hq=livnica+%C4%8Delika&amp;hnear=%D0%91%D0%B0%D1%87%D0%BA%D0%B0+%D0%A2%D0%BE%D0%BF%D0%BE%D0%BB%D0%B0,+%D0%A1%D0%B5%D0%B2%D0%B5%D1%80%D0%BD%D0%BE%D0%B1%D0%B0%D1%87%D0%BA%D0%B8+o%D0%BA%D1%80%D1%83%D0%B3,+%D0%92%D0%BE%D1%98%D0%B2%D0%BE%D0%B4%D0%B8%D0%BD%D0%B0&amp;ll=45.814002,19.655785&amp;spn=0.016242,0.042272&amp;z=14&amp;iwloc=A&amp;cid=16927251537801416053&amp;output=embed&z=6"></iframe><br /><small className='text-right'><a className='pull-right' href="https://maps.google.rs/maps?f=q&amp;source=embed&amp;hl=sr&amp;geocode=&amp;q=livnica+%C4%8Delika+ba%C4%8Dka+topola&amp;aq=&amp;sll=45.410355,20.207012&amp;sspn=2.090149,4.938354&amp;t=h&amp;ie=UTF8&amp;hq=livnica+%C4%8Delika&amp;hnear=%D0%91%D0%B0%D1%87%D0%BA%D0%B0+%D0%A2%D0%BE%D0%BF%D0%BE%D0%BB%D0%B0,+%D0%A1%D0%B5%D0%B2%D0%B5%D1%80%D0%BD%D0%BE%D0%B1%D0%B0%D1%87%D0%BA%D0%B8+o%D0%BA%D1%80%D1%83%D0%B3,+%D0%92%D0%BE%D1%98%D0%B2%D0%BE%D0%B4%D0%B8%D0%BD%D0%B0&amp;ll=45.814002,19.655785&amp;spn=0.016242,0.042272&amp;z=14&amp;iwloc=A&amp;cid=16927251537801416053" >Prikaži veću mapu</a></small>
        </div>
        <div className='col-md-2'></div>
      </div>
      <div className='row'>
        <div className='col-md-2'></div>
        <div className='col-md-8 text-left'>
            <div className='address'>
              <strong>Termovent SC Livnica čelika A.D.</strong><br/>
              Industrijska zona b.b.<br/>
              Backa Topola, 24300<br/>
              <abbr title="Phone">Phone:</abbr> +381 (0)24 713-524<br/>
              <abbr title="Phone">Fax:</abbr> +381 (0)24 715-246<br/>
              <abbr title="Phone">Email:</abbr><a href="mailto:office@livnica.com">office@livnica.com</a><br/>
            </div>
            <br/>
            <div className='address'>
              <strong>Sektor prodaje</strong><br/>
              <abbr title="Phone">Fax:</abbr> +381 (0)24 712-832<br/>
              <abbr title="Phone">Email:</abbr><a href="mailto:prodaja@livnica.com"> prodaja@livnica.com</a><br/>
            </div>
              <br/>
            <div className='address'>

              <strong>Sektor nabavke</strong><br/>
              <abbr title="Phone">Fax:</abbr> +381 (0)24 712-027<br/>
              <abbr title="Phone">Email:</abbr><a href="mailto:nabavka@livnica.com"> nabavka@livnica.com</a><br/>
            </div>
        </div>
        <div className='col-md-2'></div>
      </div>
       </div>
    )
  },
  eng(){
    return (
        <div>
      <div className='row text-center col-margin-top-doc'>
      <div className='col-md-2'></div>
        <div className='col-md-8'>
          <iframe  width="100%" height="400" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.rs/maps?f=q&amp;source=embed&amp;hl=sr&amp;geocode=&amp;q=livnica+%C4%8Delika+ba%C4%8Dka+topola&amp;aq=&amp;sll=45.410355,20.207012&amp;sspn=2.090149,4.938354&amp;t=h&amp;ie=UTF8&amp;hq=livnica+%C4%8Delika&amp;hnear=%D0%91%D0%B0%D1%87%D0%BA%D0%B0+%D0%A2%D0%BE%D0%BF%D0%BE%D0%BB%D0%B0,+%D0%A1%D0%B5%D0%B2%D0%B5%D1%80%D0%BD%D0%BE%D0%B1%D0%B0%D1%87%D0%BA%D0%B8+o%D0%BA%D1%80%D1%83%D0%B3,+%D0%92%D0%BE%D1%98%D0%B2%D0%BE%D0%B4%D0%B8%D0%BD%D0%B0&amp;ll=45.814002,19.655785&amp;spn=0.016242,0.042272&amp;z=14&amp;iwloc=A&amp;cid=16927251537801416053&amp;output=embed&z=6"></iframe><br /><small className='text-right'><a className='pull-right' href="https://maps.google.rs/maps?f=q&amp;source=embed&amp;hl=sr&amp;geocode=&amp;q=livnica+%C4%8Delika+ba%C4%8Dka+topola&amp;aq=&amp;sll=45.410355,20.207012&amp;sspn=2.090149,4.938354&amp;t=h&amp;ie=UTF8&amp;hq=livnica+%C4%8Delika&amp;hnear=%D0%91%D0%B0%D1%87%D0%BA%D0%B0+%D0%A2%D0%BE%D0%BF%D0%BE%D0%BB%D0%B0,+%D0%A1%D0%B5%D0%B2%D0%B5%D1%80%D0%BD%D0%BE%D0%B1%D0%B0%D1%87%D0%BA%D0%B8+o%D0%BA%D1%80%D1%83%D0%B3,+%D0%92%D0%BE%D1%98%D0%B2%D0%BE%D0%B4%D0%B8%D0%BD%D0%B0&amp;ll=45.814002,19.655785&amp;spn=0.016242,0.042272&amp;z=14&amp;iwloc=A&amp;cid=16927251537801416053" >Prikaži veću mapu</a></small>
        </div>
        <div className='col-md-2'></div>
      </div>
      <div className='row'>
        <div className='col-md-2'></div>
        <div className='col-md-8 text-left'>
            <div className='address'>
              <strong>Termovent SC Steel foundry J.S.C</strong><br/>
              Industrijska zona b.b.<br/>
              Backa Topola, 24300<br/>
              <abbr title="Phone">Phone:</abbr> +381 (0)24 713-524<br/>
              <abbr title="Phone">Fax:</abbr> +381 (0)24 715-246<br/>
              <abbr title="Phone">Email:</abbr><a href="mailto:office@livnica.com">office@livnica.com</a><br/>
            </div>
            <br/>
            <div className='address'>
              <strong>Sales department</strong><br/>
              <abbr title="Phone">Fax:</abbr> +381 (0)24 712-832<br/>
              <abbr title="Phone">Email:</abbr><a href="mailto:prodaja@livnica.com"> prodaja@livnica.com</a><br/>
            </div>
              <br/>
            <div className='address'>

              <strong>Procurement department</strong><br/>
              <abbr title="Phone">Fax:</abbr> +381 (0)24 712-027<br/>
              <abbr title="Phone">Email:</abbr><a href="mailto:nabavka@livnica.com"> nabavka@livnica.com</a><br/>
            </div>
        </div>
        <div className='col-md-2'></div>
      </div>
       </div>
    )
  },
  ger(){
    return (
        <div>
      <div className='row text-center col-margin-top-doc'>
      <div className='col-md-2'></div>
        <div className='col-md-8'>
          <iframe  width="100%" height="400" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.rs/maps?f=q&amp;source=embed&amp;hl=sr&amp;geocode=&amp;q=livnica+%C4%8Delika+ba%C4%8Dka+topola&amp;aq=&amp;sll=45.410355,20.207012&amp;sspn=2.090149,4.938354&amp;t=h&amp;ie=UTF8&amp;hq=livnica+%C4%8Delika&amp;hnear=%D0%91%D0%B0%D1%87%D0%BA%D0%B0+%D0%A2%D0%BE%D0%BF%D0%BE%D0%BB%D0%B0,+%D0%A1%D0%B5%D0%B2%D0%B5%D1%80%D0%BD%D0%BE%D0%B1%D0%B0%D1%87%D0%BA%D0%B8+o%D0%BA%D1%80%D1%83%D0%B3,+%D0%92%D0%BE%D1%98%D0%B2%D0%BE%D0%B4%D0%B8%D0%BD%D0%B0&amp;ll=45.814002,19.655785&amp;spn=0.016242,0.042272&amp;z=14&amp;iwloc=A&amp;cid=16927251537801416053&amp;output=embed&z=6"></iframe><br /><small className='text-right'><a className='pull-right' href="https://maps.google.rs/maps?f=q&amp;source=embed&amp;hl=sr&amp;geocode=&amp;q=livnica+%C4%8Delika+ba%C4%8Dka+topola&amp;aq=&amp;sll=45.410355,20.207012&amp;sspn=2.090149,4.938354&amp;t=h&amp;ie=UTF8&amp;hq=livnica+%C4%8Delika&amp;hnear=%D0%91%D0%B0%D1%87%D0%BA%D0%B0+%D0%A2%D0%BE%D0%BF%D0%BE%D0%BB%D0%B0,+%D0%A1%D0%B5%D0%B2%D0%B5%D1%80%D0%BD%D0%BE%D0%B1%D0%B0%D1%87%D0%BA%D0%B8+o%D0%BA%D1%80%D1%83%D0%B3,+%D0%92%D0%BE%D1%98%D0%B2%D0%BE%D0%B4%D0%B8%D0%BD%D0%B0&amp;ll=45.814002,19.655785&amp;spn=0.016242,0.042272&amp;z=14&amp;iwloc=A&amp;cid=16927251537801416053" >Prikaži veću mapu</a></small>
        </div>
        <div className='col-md-2'></div>
      </div>
      <div className='row'>
        <div className='col-md-2'></div>
        <div className='col-md-8 text-left'>
            <div className='address'>
              <strong>Die Termovent SC Stahlfabrik GmbH</strong><br/>
              Industrijska zona b.b.<br/>
              Backa Topola, 24300<br/>
              <abbr title="Phone">Phone:</abbr> +381 (0)24 713-524<br/>
              <abbr title="Phone">Fax:</abbr> +381 (0)24 715-246<br/>
              <abbr title="Phone">Email:</abbr><a href="mailto:office@livnica.com">office@livnica.com</a><br/>
            </div>
            <br/>
            <div className='address'>
              <strong>Verkaufsabteilung</strong><br/>
              <abbr title="Phone">Fax:</abbr> +381 (0)24 712-832<br/>
              <abbr title="Phone">Email:</abbr><a href="mailto:prodaja@livnica.com"> prodaja@livnica.com</a><br/>
            </div>
              <br/>
            <div className='address'>

              <strong>Einkaufsabteilung</strong><br/>
              <abbr title="Phone">Fax:</abbr> +381 (0)24 712-027<br/>
              <abbr title="Phone">Email:</abbr><a href="mailto:nabavka@livnica.com"> nabavka@livnica.com</a><br/>
            </div>
        </div>
        <div className='col-md-2'></div>
      </div>
       </div>
    )
  }
})

module.exports = Kontakt;



/** WEBPACK FOOTER **
 ** ./modules/components/Kontakt/Kontakt.js
 **/